export default __webpack_public_path__ + "static/media/camera-house-large.1a11a0c6.png";